var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6101 10.1695C11.3881 10.2649 11.4375 10.386 11.3881 10.5745L10.8481 15.2095C10.8381 15.3295 10.8331 15.4445 10.8331 15.5545C10.8331 16.0745 11.0224 16.4772 11.3008 16.843C11.4375 17.0227 11.8211 17.2634 12.2631 17.3341C12.9331 17.3341 13.4331 17.0945 13.9131 16.6045C14.3931 16.1145 14.7331 15.4695 14.9331 14.6695C14.9031 14.5695 14.8131 14.4195 14.6631 14.2195C14.5131 14.0195 14.4031 13.8995 14.3331 13.8595C14.1931 14.3995 13.9831 14.8845 13.7031 15.3145C13.4331 15.7345 13.1331 15.9445 12.8031 15.9445C12.4831 15.9445 12.3031 15.8145 12.2631 15.5545C12.2431 15.4545 12.2331 15.3395 12.2331 15.2095C12.2331 15.0695 12.2581 14.8995 12.3081 14.6995C12.3081 14.6695 12.5031 13.1495 12.8931 10.1395C12.8075 9.85196 12.0021 10.0397 11.6101 10.1695Z",
    fill: "#EC187B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1633 6.66797C11.8333 6.66797 11.5533 6.78797 11.3233 7.02797C11.0933 7.25797 10.9783 7.53797 10.9783 7.86797C10.9783 8.19797 11.0933 8.47797 11.3233 8.70797C11.5533 8.93797 11.8333 9.05297 12.1633 9.05297C12.4933 9.05297 12.7733 8.93797 13.0033 8.70797C13.2433 8.47797 13.3633 8.19797 13.3633 7.86797C13.3633 7.53797 13.2433 7.25797 13.0033 7.02797C12.7733 6.78797 12.4933 6.66797 12.1633 6.66797Z",
    fill: "#EC187B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.63a3e651ec52b9ca9df51267a408d71f.svg";
export { ForwardRef as ReactComponent };